// extracted by mini-css-extract-plugin
export default {"button":"CopyLinkIconButton_button__N04pv","spinner":"CopyLinkIconButton_spinner__6iofz","copy-link-spin":"CopyLinkIconButton_copy-link-spin__pPTpO"};